module.exports = __webpack_public_path__ + "img/00.bf8e628d.png";